import * as _ from 'lodash';

// Libraries
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import { Location } from '@angular/common';

// Services
import { BookingHolidayService } from '../../../services';
import { SessionStorageService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
import { ClassPayment, ClassChild, BookingItem, Payment,Questionnaire, Answer } from '../../../models';

@Component({
    selector: 'children-list',
    template: require('./ViewBookingComponent.html'),
    styles: [ require('./ViewBookingComponent.sass') ]
})

export class ViewBookingComponent extends BookingComponent implements OnInit {
    private bookingInfo: any;
    private bookingId: string;
    private sub: any;
    private paymentType: string;
    private payment: Payment;
    private questionnaire: Questionnaire[] = [];
    currentSemester: any;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected catalogService: CatalogService,
        protected location: Location
        
    ){
        super(router, services, sessionStorageService, catalogService);
    }

    ngOnInit() {
        this.payment = new Payment; 
        // Get id from param
        this.sub = this.route.params.subscribe(
            params => {
                this.bookingId = params['id'];
                // Get booking info by id
                this.getBookingInfo();
            }
        )
        this.getSemester();
    }
    
    protected getSemester() { 
        this.catalogService.getSemesters()
            .subscribe(
                semesterList => {
                    this.currentSemester = _.find(semesterList, 'is_current');
                },
                error => {
                    console.log("Cannot get semester list from API.");
            }
        )
    }

    submitPayment() {
        this.payment.booking_id = this.bookingInfo.id;
        this.payment.currency = 'VND';
        this.payment.zone = this.paymentType;
        this.payment.amount = this.bookingInfo.balance;
        this.services.payment(this.payment)
            .subscribe(
                (result: any) => {
                    window.location.href = result.url
                    this.local.setData('updateBookingDetail', result)
                },
                (error: any) => {

                }
            )
    }

    disabledSumit() {
        if(this.paymentType === undefined) {
            return true
        }
        else {
            return false
        }
    }

    getBookingInfo() {
        let query = {
            id: this.bookingId,
            page: 1
        };

        this.services.getBooking(query).subscribe(
            result => {
                if(result.data){
                    // Get booking info
                    this.bookingInfo = result.data[0];
                    // Sort hol_weeks
                    this.bookingInfo.hol_weeks = _.sortBy(this.bookingInfo.hol_weeks, (o: any) => { return o.name });

                    if(this.bookingInfo.question_answer && this.bookingInfo.question_answer.length > 0){
                        this.getQuestionnaire();                       
                    }
                }
            },
            error => {

            }
        )
    }

    getQuestionnaire(){
        this.services.getQuestionnaire(true).subscribe(
            result => {
                if(result)
                    //get all questionnaire
                    this.questionnaire = result;

                    //map question to answer
                    this.bookingInfo.question_answer.forEach((val: Answer ) =>  {
                            let question =  this.questionnaire.find(item => item.id == val.question_id);
                            val.question = question.question;
                    })
            },
            error => {

            }
        )       
    }

    downloadLunchMenu() {
        const link = window.document.createElement('a');
        link.href = '/assets/AIS Summer Menu - 2017-18.xlsx';
        link['download'] = "AIS Summer Menu - 2017-18.xlsx";
        
        document.body.appendChild(link);
        link.click();

        setTimeout(function(){
            document.body.removeChild(link);
        }, 100);
    }
    
    ngOnDestroy() {
        // Unsubscribe
        this.sub.unsubscribe();
    }

    isHidePaymentMethod() {
        const MAX_WEEK = 5;
        return this.bookingInfo.hol_weeks.length < MAX_WEEK;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/view-booking/ViewBookingComponent.ts